import React from 'react';
import RegisterForm from './RegisterForm';

function Register() {
  return (
    <div className="bg-login-background bg-cover">
      <RegisterForm />
    </div>
  );
}

export default Register;
